/**
 * Typowe wartości parametrów elektrycznych — podpowiedzi w polach, gdy karty
 * katalogowej brakuje.
 *
 * ═══ TO JEST PLIK DO RĘCZNEJ EDYCJI ═══
 * Zmiana podpowiedzi to zmiana liczby w `TYPOWE` poniżej.
 *
 * PO CO: komplet danych elektrycznych ma ok. 12% modułów i 20% falowników, więc
 * przepisywanie ich z karty producenta to ścieżka główna, nie awaryjna. Puste pole
 * z etykietą „napięcie obwodu otwartego modułu (Voc)" nie mówi nic komuś, kto tej
 * karty akurat nie ma pod ręką — a rząd wielkości mówi wszystko: od razu widać,
 * czy wpisało się 49 czy 4,9.
 *
 * PODPOWIEDŹ, NIE WARTOŚĆ DOMYŚLNA. To `placeholder`, nie `value`: pole zostaje
 * puste i formularz nadal wymaga wpisania liczby. Podstawienie tych wartości
 * z automatu dałoby projekt policzony dla wymyślonego modułu, wyglądający
 * dokładnie tak samo jak policzony dla prawdziwego.
 *
 * Klucze odpowiadają polom z `braki` zwracanym przez `/api/v1/electrical/strings`
 * (backend_api/electrical/api.py). Parametry, o które nie pytamy, są tu pominięte.
 */

export const TYPOWE = {
  panel: {
    pmax_w: { typowa: 500, jednostka: 'W', zakres: '430–600 W' },
    voc_v: { typowa: 49, jednostka: 'V', zakres: '38–55 V' },
    vmp_v: { typowa: 41, jednostka: 'V', zakres: '31–46 V' },
    isc_a: { typowa: 14, jednostka: 'A', zakres: '11–18,5 A' },
    imp_a: { typowa: 13, jednostka: 'A', zakres: '10–17,5 A' },
  },
  inverter: {
    dc_max_voltage_v: { typowa: 1100, jednostka: 'V', zakres: '600–1100 V' },
    mppt_v_min: { typowa: 160, jednostka: 'V', zakres: '80–250 V' },
    mppt_v_max: { typowa: 1000, jednostka: 'V', zakres: '500–1000 V' },
    // Moc AC bierze się z nazwy produktu („SUN-8K" to 8 kW), więc zamiast typowej
    // liczby podpowiadamy, GDZIE jej szukać — podanie tu „10 kW" mogłoby skłonić
    // do przyjęcia cudzej mocy zamiast odczytania własnej.
    ac_power_kw: { typowa: null, jednostka: 'kW', podpowiedz: 'zwykle w nazwie modelu' },
  },
}

/** Tekst do `placeholder` albo `null`, gdy dla tego pola nie mamy podpowiedzi. */
export const podpowiedzPola = (strona, pole) => {
  const t = TYPOWE[strona]?.[pole]
  if (!t) return null
  if (t.typowa == null) return t.podpowiedz || null
  const liczba = String(t.typowa).replace('.', ',')
  return `zwykle ok. ${liczba} ${t.jednostka}`
}

/** Pełny opis z zakresem — do dymka pod polem. */
export const zakresPola = (strona, pole) => TYPOWE[strona]?.[pole]?.zakres || null
